const RefreshIcon = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.375 0.75L11.8234 1.58833C12.1267 2.1551 12.2783 2.43849 12.1781 2.55985C12.0778 2.68122 11.7476 2.5832 11.0873 2.38716C10.4272 2.19117 9.7263 2.08572 9 2.08572C5.06497 2.08572 1.875 5.18135 1.875 9.00003C1.875 10.2594 2.22197 11.4402 2.8282 12.4572M6.625 17.25L6.17652 16.4117C5.87331 15.8449 5.7217 15.5615 5.82195 15.4401C5.9222 15.3188 6.25237 15.4168 6.91267 15.6129C7.57283 15.8088 8.2737 15.9143 9 15.9143C12.935 15.9143 16.125 12.8187 16.125 9.00003C16.125 7.74063 15.778 6.55986 15.1718 5.54286"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default RefreshIcon;
